module.exports = __webpack_public_path__ + "img/img17.fc56e6f2.png";